import { IonIcon, IonImg } from '@ionic/react';
import { ellipsisVertical, helpCircleOutline, people } from 'ionicons/icons';

export const AppMessages = {
    prayerStorage: {
        messageId: 'prayerStorage',
        messageBody: <p>All prayers saved here will be stored on your device and will never be uploaded online
        unless you share them with your group or synchronize them with another device. Also, using this prayer feature
        does not require being signed into a group, so your saved prayers will be visible to anyone who can log into your device.</p>
    },
    prayerTutorial: {
        messageId: 'prayerTutorial',
        messageBody: <p>Learn how our app can help you <i>Pray Distraction Free</i> by watching our Prayer App Guide video. You can also click the <IonIcon icon={helpCircleOutline}></IonIcon> in the top right corner of this page to see the guide anytime you want.</p>
    },
    syncBiblePlanWithGroup: {
        messageId: 'syncBiblePlanWithGroup',
        messageBody: <p>Start reading the Bible with your group by synchronizing your Bible reading schedule with them.</p>
    },
    createBiblePlanForGroup: {
        messageId: 'createBiblePlanForGroup',
        messageBody: <p>Set up a Bible reading plan for you and your group to read through the Bible together.</p>
    },
    installWebAppAlert: {
        messageId: 'installWebAppAlert',
        messageBody: <p>Installing a link to this web app on your device's home screen makes it work like a normal app. Would you like to get started?</p>
    },
    installWebAppConnectedGroup: {
        messageId: 'installWebAppConnectedGroup',
        messageBody: <p>Stay connected with your group by installing this app on your device. Would you like to get started?</p>
    },
    appFeedbackRequest: {
        messageId: 'appFeedbackRequest',
        messageBody: <p>Please give us some feedback...</p>
    },
    fellowshipGroupInstructions: {
        messageId: 'fellowshipGroupInstructions',
        messageBody: <div><h2><b>GETTING STARTED GUIDE:</b></h2><br />
            <p>You can use the <IonIcon icon={people}></IonIcon> located in the top left corner of this page to manage your group and if you are the group admin, you can also <u>invite new members</u> to your group from here. 
            You can use the <IonIcon icon={ellipsisVertical}></IonIcon> located in the top right corner of this page to manage your account and <u>update your profile</u> info.
            The drop down selector at the top center of this page indicates your <u>current active group</u> and if you are a member of multiple groups, it allows you to <u>switch between groups</u>.</p><IonImg src='https://biblestudytogether.com/wp-content/uploads/2023/12/app-group-instruction.png'></IonImg></div>
    },
    readingHeaderInstructions: {
        messageId: 'readingHeaderInstructions',
        messageBody: <div><h2><b>GETTING STARTED GUIDE: </b></h2><IonImg src='https://biblestudytogether.com/wp-content/uploads/2023/12/app-reading-header-instructions.png'></IonImg></div>
    },
}